export default __webpack_public_path__ + "static/media/img-0699-san-marino-premium-face.00788f47.png";